import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import InfoCard from "src/components/InfoCard";
import Layout from "src/components/Layout";
import { imageUrl } from "src/network/fullUrl";

interface PageData {
  "Node.title": string;
  "Node.body": string;
  img_url: string;
}

const DynamicPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [pageData, setPageData] = useState<PageData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://dotmedica.com/nodes/getPage/${slug}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch page data");
        }
        const data = await response.json();
        setPageData(data);
      } catch (err: any) {
        setError(err.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, [slug]);

  const processHtmlContent = (html: string): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Update all <img> tags to use the imageUrl function
    const images = doc.querySelectorAll("img");
    images.forEach((img) => {
      const src = img.getAttribute("src");
      if (src) {
        img.setAttribute("src", imageUrl(src));
      }
    });

    return doc.body.innerHTML;
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!pageData) {
    return <div>No content available</div>;
  }

  return (
    <Layout>
      <InfoCard
        image={imageUrl(pageData.img_url)}
        title={pageData["Node.title"]}
        imageTitle={pageData["Node.title"]}
      >
        <div
          style={{ width: '100%', maxWidth: '800px', overflow: 'hidden' }} // Added overflow and maxWidth
          dangerouslySetInnerHTML={{
            __html: processHtmlContent(pageData["Node.body"] || ""),
          }}
        />
      </InfoCard>
    </Layout>
  );
};

export default DynamicPage;
  